/*global fbq*/
/*global dataLayer*/
var TRACKING_CATEGORY = 'ViewContent';
$(document).ready(function() {
    var name = $('h1.customizeid-product-title').text();
    var id = $('span.product-id').first().text().trim();
    var price = $('div.value').text().trim().replace('$', '');
    var currency = 'USD';
    var item_type = $('div[data-product-type]').attr('data-product-type');
    var item_description = $('.product-description > p').text();
    var item_category = $('div[data-primary-category]').attr('data-primary-category');
    if (item_category == 'smart-card'){
        item_category = 'Smart Ids';
    } else if (item_category == 'medical-ids-bracelets'){
        item_category = 'Bracelets';
    } else if (item_category == 'medical-ids-necklaces'){
        item_category = 'Necklaces';
    }
    var o = {
        item_price:    price,
        currency:      currency,
        item_name:     name,
        item_tag:      item_description,
        item_type:     item_type,
        item_category: item_category,
        item_ids:      id
    };
    console.log('ViewContent', o);
    fbq('track', TRACKING_CATEGORY, o);

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        'event':     'view_new_pdp',
        'ecommerce': {
            'detail': {
                'products': [{
                    'name':     name,
                    'id':       id,
                    'price':    price,
                    'brand':    'Medicalert',
                    'tag':      item_description,
                    'type':     item_type,
                    'category': item_category
                }]
            }
        }
    });
});
